import { useEffect, useState } from 'react'
import { formatSSN, maskSSN } from '../../../utils/ssnUtils'
import {
  EyeInvisibleOutlined,
  EyeOutlined,
  CloseOutlined
} from '@ant-design/icons'

import './SSNInput.css'

const SSNInput = ({
  value,
  onChange = () => {},
  shouldShowFakessn,
  ...others
}) => {
  const [SSN, setSSN] = useState('')
  const [isMasked, setIsMasked] = useState(true)

  useEffect(() => {
    setSSN(value || '')
  }, [value])

  const handleChange = e => {
    const value = e.target?.value

    // If the value contains fewer characters than the SSN length after removing hyphens
    if (value?.replace(/-/g, '')?.length < SSN?.length) {
      const last = SSN?.length - 1
      const newSSN = SSN?.slice(0, last) // Keep only the characters up to the last character in SSN
      setSSN(newSSN)
      onChange(newSSN)
      return
    }

    // insert only numbers
    let numValue = value.replace(/\D/g, '')

    let newSSN = ''
    // If SSN already has more than 5 characters, replace only the first 5 and concat numValue
    if (SSN.length > 5) {
      newSSN = SSN.slice(0, 5) + numValue
    } else {
      // Otherwise, append numValue to SSN
      newSSN = SSN + numValue
    }

    // only 9 digits are allowed
    if (newSSN.length > 9) {
      return
    }

    setSSN(newSSN)
    onChange(newSSN)
  }

  if (shouldShowFakessn) {
    return <FakeSSNComponent {...others} />
  }

  return (
    <div className='ssn-input'>
      <input
        type='text'
        data-private
        id='ssn'
        name='ssn'
        value={isMasked ? maskSSN(formatSSN(SSN)) : formatSSN(SSN)}
        onChange={handleChange}
        autoComplete='off'
      />
      {isMasked ? (
        <EyeOutlined onClick={() => setIsMasked(false)} />
      ) : (
        <EyeInvisibleOutlined onClick={() => setIsMasked(true)} />
      )}
    </div>
  )
}

const FakeSSNComponent = ({ ssnLast4, clearLast4 }) => {
  return (
    <div className='ssn-input'>
      <input
        type='text'
        id='fake-ssn'
        name='fake-ssn'
        value={`XXX-XX-${ssnLast4}`}
        autoComplete='off'
        disabled
      />
      <CloseOutlined onClick={clearLast4} />
    </div>
  )
}

export default SSNInput
